type Config = Record<string, any>;

type Node = Record<string, any> & {
  props: Record<string, any> & {
    config: Config;
  };
};

export function nodeRemoveNullish(
  node: Node,
  removableFields: string[] | null | undefined
): Node {
  if (!removableFields?.length) {
    return node;
  }
  return {
    ...node,
    props: {
      ...node.props,
      config: configRemoveNullish(node.props.config, removableFields)
    }
  };
}

export function configRemoveNullish(
  config: Config,
  removableFields: string[] | null | undefined
): Config {
  if (!removableFields?.length) {
    return config;
  }
  return Object.fromEntries(
    Object.entries(config).filter(([key, value]) => {
      return !removableFields.includes(key) || !isNulish(value);
    })
  );
}

function isNulish(str: any) {
  return str === null || str === undefined || str === '';
}
